import { Button, Input, InputOnChangeData } from '@fluentui/react-components';
import {SubtractCircleRegular, AddCircleRegular} from '@fluentui/react-icons';
import React from 'react';

interface INumberInputProps {
    value: number;
    onChange: (value: number) => void;
    style?: React.CSSProperties;
    includeButtons?: boolean;
    disabled?: boolean;
    // Extra class(es) appended to the input (the button variant keeps its number-with-buttons class).
    className?: string;
}

const NumberInput: React.FC<INumberInputProps> = (props) => {
    const [tempValue, setTempValue] = React.useState(props.value.toString());

    React.useEffect(() => {
        setTempValue(props.value.toString());
    }, [props.value])

    const onBlur = () => {
        const parsedValue = parseInt(tempValue);
        if (parsedValue == props.value) return;
        props.onChange(isNaN(parsedValue) ? 1 : parsedValue);
    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement>, d: InputOnChangeData) => {
        setTempValue(d.value);
    }

    const increment = () => {
        const parsedValue = parseInt(tempValue);
        props.onChange(isNaN(parsedValue) ? 1 : parsedValue + 1);
    }

    const decrement = () => {
        const parsedValue = parseInt(tempValue);
        props.onChange(isNaN(parsedValue) ? 1 : parsedValue - 1);
    }

    if (props.includeButtons) return (<>
        <Input
            contentBefore={<SubtractCircleRegular onClick={decrement} />}
            contentAfter={<AddCircleRegular onClick={increment} />}
            type="number"
            inputMode='numeric'
            value={tempValue}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={(e) => {if(e.key === 'Enter') onBlur()}}
            style={props.style}
            className={props.className ? `number-with-buttons ${props.className}` : 'number-with-buttons'}
            disabled={props.disabled}
        />
    </>)

    return (
        <Input
            type="number"
            value={tempValue}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={(e) => {if(e.key === 'Enter') onBlur()}}
            style={props.style}
            className={props.className}
            disabled={props.disabled}
        />
    );
};

export default NumberInput;